export default "__VITE_ASSET__DdULhafG__"